module.exports = "https://r.nearpod.com/assets/media/image/npp_thumbnail__img-4bfdbd6c02c4e2673af4eec249e8b66d.png";